import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useState } from 'react';
import { reqMainBrAction } from '../../modules/hp/mainModule';
import HpBrandItem from './HpBrandItem';
import Modal from 'react-modal';
import LoginPopup, { LoginPopupStyles } from '../common/popup/LoginPopup';
import { brandAction } from '../../modules/su/userBrandModule';
import { setUserBrandAddAction, setUserBrandDelAction } from '../../modules/common/brandModule';
import { setCurMenuAction } from '../../modules/common/headerModule';
import {isMobileOnly} from 'react-device-detect';

const HpBrandListBlock = styled.div`
    //max-width: 1176px;
    margin: 0 auto;
    ${isMobileOnly&&`
    width:100vw;
    // margin-left: -4vw;
    padding: 0 4vw 40px;    
    margin-top: 15px
    `};

`;

const HpBrandListContainerBlock = styled.div`
    max-width: 1176px;
    margin: 0 auto;
    
    ${isMobileOnly?`
        // .section-title {text-align:left; font-size:20px;margin-bottom:45px; transform: translateY(-13px);}
        .recc_brand-list {margin-top: 15px;}        
        .section-title {
            display:flex; align-items:center; justify-content:space-between;line-height:29px;height:29px; font-size: 20px;       
            margin-bottom:0;     
            a {
                padding:0 15px;
                position: unset;
                font-size: unset;
                img {width: 6px; height:12px;}
            }           
         }
    `:`
        .section-title {transform: translateY(-20px); margin-bottom: 30px;}
        .recc_brand-list {margin-top: -50px;}
    `}

    .mobile-brand {
        margin-bottom: 40px;
    }
    .mobile-brand:last-child {
        margin-bottom: 0px;
    }
`;
const HpBrandList = () => {

    const dispatch = useDispatch();

    const [openModal, setOpenModal] = useState(false);
    const [fromLoginPU, setFromLoginPU] = useState(false);
    const [addClipId, setAddClipId] = useState(null);
    const [delClipId, setDelClipId] = useState(null);

    const { mainBrItems, accessToken, clipBrandIds, id, brandClipResult } = useSelector(
        ({ loadingReducer, mainReducer, userReducer, userBrandReducer, brandItemsReducer }) => ({
            loading: loadingReducer['main/MAIN_BR'],
            mainBrItems: mainReducer.mainBrItems,
            accessToken: userReducer.accessToken,
            id: userReducer.id,
            clipBrandIds: userBrandReducer.clipBrandIds,
            brandClipResult: brandItemsReducer.brandClipResult
        })
    );

    useEffect(() => {
        // console.log("useEffect ++++++++ 1")
        dispatch(reqMainBrAction());
        setAddClipId(null);
        setDelClipId(null);
        setFromLoginPU(false);

        if (accessToken !== null) {
            dispatch(brandAction(id));
        }

    }, [dispatch])


    useEffect(() => {
        // console.log("useEffect ++++++++ 2")
        // 로그인 상태면 이 항목이 클립 항목인지 확인
        if (accessToken !== null) {
            dispatch(setCurMenuAction('main'));
            onCloseModal();
            dispatch(brandAction(id));

            if (fromLoginPU === true) {
                dispatch(brandAction(id));
                setFromLoginPU(false);

                if (addClipId !== null) {
                    dispatch(setUserBrandAddAction(id, addClipId));
                    setAddClipId(null);
                }

                if (delClipId !== null) {
                    dispatch(setUserBrandDelAction(id, delClipId));
                    setDelClipId(null);
                }
            }
        }

    }, [accessToken])


    useEffect(() => {
        // console.log("useEffect ++++++++ 4")

    }, [clipBrandIds])

    // 추가 / 삭제 가 완료 되면 호출
    useEffect(() => {
        // console.log("useEffect ++++++++ 5")
        if (accessToken !== null) {
            dispatch(brandAction(id));
        }
    }, [brandClipResult]);


    const onOpenModal = () => {
        setOpenModal(true);
    }

    // Modal 닫기
    const onCloseModal = () => {
        setOpenModal(false);
    }

    // 클릭 추가 / 삭제 요청
    const handleClip = (param) => {
        // console.log("param : " + param);

        //비로그인
        if (accessToken === null) {
            onOpenModal();
            setFromLoginPU(true); //로그인 팝업 후, 종료시 다시 요청하기 위해서..
            setAddClipId(param);
        }
        else {
            // 바로 추가나 삭제 처리
            if (clipBrandIds != null && clipBrandIds.length > 0 && clipBrandIds.includes(param)) {
                dispatch(setUserBrandDelAction(id, param));
            }
            else {
                dispatch(setUserBrandAddAction(id, param));
            }
        }
    }

    const checkClip = (brandid) => {
        if (accessToken === null) {
            return false;
        } else {
            if (clipBrandIds != null && clipBrandIds.length > 0 && clipBrandIds.includes(brandid)) {
                return true;
            }
        }

        return false;
    }

    if (mainBrItems === null || mainBrItems === undefined) {
        return <div />;
    }

    return (
        <HpBrandListBlock className="recc_brand-section">
            <HpBrandListContainerBlock>
            <div >
                <div className="sz-wrap">
                    <div className="section-title">
                        <div><b>브랜드</b> 모르면 어디?</div>
                        <Link to="/br">{isMobileOnly?<img src="/assets/images/icon/arrow_right.svg"/>:"전체보기"}</Link>
                    </div>

                    <ul className="recc_brand-list">
                        {
                            mainBrItems.map((curitem) => {
                                return <HpBrandItem
                                    key={curitem.id}
                                    brandinfo={curitem}
                                    reqClip={handleClip}
                                    isClip={checkClip(curitem.id)} />
                            })
                        }
                    </ul>
                </div>
            </div>
            </HpBrandListContainerBlock>
            <Modal
                isOpen={openModal}
                onRequestClose={onCloseModal}
                style={LoginPopupStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                <LoginPopup onClosePopup={onCloseModal}/>
            </Modal>
        </HpBrandListBlock>
    );
};

export default HpBrandList;
